import { useIssuesStore } from "@/store/zustand/issues-store";
import { useSupabaseStore } from "@/store/zustand/supabaseStore";
import { FeaturePRD } from "@/types/issues";
import { useCanvasId } from "@/utils/utils";
import _ from "lodash";
import { useCallback, useEffect, useState } from "react";

const THROTTLE_DELAY_MS = 1000;

const throttledEditSupabase = _.throttle(
  async (
    supabaseClient: any,
    field: string,
    newValue: any,
    canvasId: string,
    featurePrd: FeaturePRD | null,
    updateFeaturePRD: any
  ) => {
    updateFeaturePRD(supabaseClient, {
      id: featurePrd?.id,
      canvas_id: canvasId,
      [field]: newValue,
    });
  },
  THROTTLE_DELAY_MS,
  { leading: true, trailing: true }
);

export const useEditPrd = () => {
  const canvasId = useCanvasId();

  const updateFeaturePRD = useIssuesStore((state) => state.updateFeaturePRD);
  const currentIssue = useIssuesStore(
    (state) => state.canvasIdToIssue[canvasId]
  );

  const supabaseClient = useSupabaseStore((state) => state.supabaseClient);

  return useCallback(
    async (field: string, newValue: any, throttleSupabase?: boolean) => {
      if (!supabaseClient || !currentIssue) {
        return;
      }

      const featurePrd = currentIssue.featurePrd;

      if (!featurePrd) {
        return;
      }

      if (newValue === featurePrd[field]) {
        return;
      }

      if (throttleSupabase) {
        throttledEditSupabase(
          supabaseClient,
          field,
          newValue,
          canvasId,
          featurePrd,
          updateFeaturePRD
        );
      } else {
        updateFeaturePRD(supabaseClient, {
          id: featurePrd?.id,
          canvas_id: canvasId,
          [field]: newValue,
        });
      }
    },
    [supabaseClient, canvasId, currentIssue]
  );
};
